import { defineComponent as _defineComponent } from 'vue'
import ResizeSocialSection from "./components/ResizeSocialGroup.vue";
import ResizeSocial from "./components/ResizeSocial.vue";
import ResizeUpload from "./components/ResizeUpload.vue";
import groups from "./data";
import { nextTick, ref } from "vue";
import { ImageTransform } from "./types";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const image = ref<HTMLImageElement>();

const transform = ref<ImageTransform>({
  cropWidth: undefined,
  cropHeight: undefined,
  cropX: 0.5,
  cropY: 0.5,
  focusX: 0.5,
  focusY: 0.5
});

const reset = () => {
  image.value = undefined;

  transform.value = {
    cropWidth: undefined,
    cropHeight: undefined,
    cropX: 0.5,
    cropY: 0.5,
    focusX: 0.5,
    focusY: 0.5
  };
};

const onImageUpload = (uploadedImage: HTMLImageElement | undefined): void => {
  image.value = uploadedImage;
};

const updateTransform = async (props: Partial<ImageTransform>): Promise<void> => {
  await nextTick();
  transform.value = {
    ...transform.value,
    ...props
  };
};

return { __sfc: true,image, transform, reset, onImageUpload, updateTransform, ResizeSocialSection, ResizeSocial, ResizeUpload, groups }
}

})